import { render, staticRenderFns } from "./Backings.vue?vue&type=template&id=264e9db1"
import script from "./Backings.vue?vue&type=script&lang=js"
export * from "./Backings.vue?vue&type=script&lang=js"
import style0 from "./Backings.vue?vue&type=style&index=0&id=264e9db1&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports